"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeProvider = require("@gravity/theme-provider");
var _themeMapper = require("@gravity/theme-mapper");
var _utils = require("@gravity/utils");
var _excluded = ["lines", "maxLines", "children"];
var _jsxFileName = "/codebuild/output/src4001455011/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/TextPreview/lib/TextPreview.js",
  _templateObject,
  _templateObject2,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1dg2fatkai() {
  var path = "/codebuild/output/src4001455011/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/TextPreview/lib/TextPreview.js";
  var hash = "a8b824cdf9957a419ed3c453c01c2333e6fe0605";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src4001455011/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/TextPreview/lib/TextPreview.js",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 26
        },
        end: {
          line: 10,
          column: 42
        }
      },
      "1": {
        start: {
          line: 12,
          column: 17
        },
        end: {
          line: 12,
          column: 27
        }
      },
      "2": {
        start: {
          line: 14,
          column: 13
        },
        end: {
          line: 100,
          column: 2
        }
      },
      "3": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 31,
          column: 37
        }
      },
      "4": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 34,
          column: 19
        }
      },
      "5": {
        start: {
          line: 37,
          column: 23
        },
        end: {
          line: 37,
          column: 59
        }
      },
      "6": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 44,
          column: 6
        }
      },
      "7": {
        start: {
          line: 46,
          column: 46
        },
        end: {
          line: 46,
          column: 57
        }
      },
      "8": {
        start: {
          line: 50,
          column: 37
        },
        end: {
          line: 50,
          column: 48
        }
      },
      "9": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 77,
          column: 19
        }
      },
      "10": {
        start: {
          line: 80,
          column: 23
        },
        end: {
          line: 80,
          column: 94
        }
      },
      "11": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 87,
          column: 6
        }
      },
      "12": {
        start: {
          line: 89,
          column: 46
        },
        end: {
          line: 89,
          column: 57
        }
      },
      "13": {
        start: {
          line: 93,
          column: 37
        },
        end: {
          line: 93,
          column: 48
        }
      },
      "14": {
        start: {
          line: 102,
          column: 20
        },
        end: {
          line: 109,
          column: 1
        }
      },
      "15": {
        start: {
          line: 103,
          column: 2
        },
        end: {
          line: 108,
          column: 4
        }
      },
      "16": {
        start: {
          line: 111,
          column: 0
        },
        end: {
          line: 121,
          column: 2
        }
      },
      "17": {
        start: {
          line: 123,
          column: 0
        },
        end: {
          line: 129,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 29,
            column: 13
          },
          end: {
            line: 29,
            column: 14
          }
        },
        loc: {
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 31,
            column: 37
          }
        },
        line: 30
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 32,
            column: 24
          },
          end: {
            line: 32,
            column: 25
          }
        },
        loc: {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 34,
            column: 19
          }
        },
        line: 33
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 37,
            column: 14
          },
          end: {
            line: 37,
            column: 15
          }
        },
        loc: {
          start: {
            line: 37,
            column: 23
          },
          end: {
            line: 37,
            column: 59
          }
        },
        line: 37
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 38,
            column: 7
          }
        },
        loc: {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 44,
            column: 6
          }
        },
        line: 39
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 46,
            column: 37
          },
          end: {
            line: 46,
            column: 38
          }
        },
        loc: {
          start: {
            line: 46,
            column: 46
          },
          end: {
            line: 46,
            column: 57
          }
        },
        line: 46
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 50,
            column: 28
          },
          end: {
            line: 50,
            column: 29
          }
        },
        loc: {
          start: {
            line: 50,
            column: 37
          },
          end: {
            line: 50,
            column: 48
          }
        },
        line: 50
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 75,
            column: 24
          },
          end: {
            line: 75,
            column: 25
          }
        },
        loc: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 77,
            column: 19
          }
        },
        line: 76
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 80,
            column: 14
          },
          end: {
            line: 80,
            column: 15
          }
        },
        loc: {
          start: {
            line: 80,
            column: 23
          },
          end: {
            line: 80,
            column: 94
          }
        },
        line: 80
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 81,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        },
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 87,
            column: 6
          }
        },
        line: 82
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 89,
            column: 37
          },
          end: {
            line: 89,
            column: 38
          }
        },
        loc: {
          start: {
            line: 89,
            column: 46
          },
          end: {
            line: 89,
            column: 57
          }
        },
        line: 89
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 93,
            column: 28
          },
          end: {
            line: 93,
            column: 29
          }
        },
        loc: {
          start: {
            line: 93,
            column: 37
          },
          end: {
            line: 93,
            column: 48
          }
        },
        line: 93
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 102,
            column: 20
          },
          end: {
            line: 102,
            column: 21
          }
        },
        loc: {
          start: {
            line: 103,
            column: 2
          },
          end: {
            line: 108,
            column: 4
          }
        },
        line: 103
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 31,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 7
          },
          end: {
            line: 30,
            column: 18
          }
        }, {
          start: {
            line: 30,
            column: 22
          },
          end: {
            line: 30,
            column: 45
          }
        }, {
          start: {
            line: 30,
            column: 49
          },
          end: {
            line: 30,
            column: 82
          }
        }, {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 31,
            column: 37
          }
        }],
        line: 30
      },
      "1": {
        loc: {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 34,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 7
          },
          end: {
            line: 33,
            column: 18
          }
        }, {
          start: {
            line: 33,
            column: 22
          },
          end: {
            line: 33,
            column: 45
          }
        }, {
          start: {
            line: 33,
            column: 49
          },
          end: {
            line: 33,
            column: 88
          }
        }, {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 34,
            column: 19
          }
        }],
        line: 33
      },
      "2": {
        loc: {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 44,
            column: 6
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 39,
            column: 20
          }
        }, {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 44,
            column: 6
          }
        }],
        line: 39
      },
      "3": {
        loc: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 77,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 76,
            column: 7
          },
          end: {
            line: 76,
            column: 18
          }
        }, {
          start: {
            line: 76,
            column: 22
          },
          end: {
            line: 76,
            column: 45
          }
        }, {
          start: {
            line: 76,
            column: 49
          },
          end: {
            line: 76,
            column: 88
          }
        }, {
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 77,
            column: 19
          }
        }],
        line: 76
      },
      "4": {
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 87,
            column: 6
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 20
          }
        }, {
          start: {
            line: 83,
            column: 6
          },
          end: {
            line: 87,
            column: 6
          }
        }],
        line: 82
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0, 0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a8b824cdf9957a419ed3c453c01c2333e6fe0605"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1dg2fatkai = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1dg2fatkai();
var _ref = (cov_1dg2fatkai().s[0]++, _stylingConstants.default),
  font = _ref.font,
  spacing = _ref.spacing;
var fontSize = (cov_1dg2fatkai().s[1]++, font.sizeS);
var Text = (cov_1dg2fatkai().s[2]++, (0, _utils.withThemedStyles)(_styledComponents.default.p.attrs({
  className: 'g-TextPreview semantic-no-styling'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    display: block;\n    display: -webkit-box;\n    font-size: ", ";\n    margin: 0;\n    width: 100%;\n    height: 100%;\n    line-height: ", ";\n    overflow: hidden;\n    white-space: normal;\n    z-index: 2;\n    margin-top: ", ";\n    color: ", ";\n    background-color: ", ";\n    -webkit-transition: height 0.5s; /* Safari */\n    transition: height 0.5s;\n    height: ", ";\n    ", ";\n    text-overflow: ellipsis;\n    @supports (-webkit-line-clamp: ", ") {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-line-clamp: ", ";\n      -webkit-box-orient: vertical;\n      &:after {\n        display: none;\n      }\n    }\n  "])), fontSize, font.sizeL, spacing.xsmall, function (props) {
  cov_1dg2fatkai().f[0]++;
  cov_1dg2fatkai().s[3]++;
  return (cov_1dg2fatkai().b[0][0]++, props.theme) && (cov_1dg2fatkai().b[0][1]++, props.theme.textPreview) && (cov_1dg2fatkai().b[0][2]++, props.theme.textPreview.textColor) || (cov_1dg2fatkai().b[0][3]++, _stylingConstants.default.color.baseText);
}, function (props) {
  cov_1dg2fatkai().f[1]++;
  cov_1dg2fatkai().s[4]++;
  return (cov_1dg2fatkai().b[1][0]++, props.theme) && (cov_1dg2fatkai().b[1][1]++, props.theme.textPreview) && (cov_1dg2fatkai().b[1][2]++, props.theme.textPreview.backgroundColor) || (cov_1dg2fatkai().b[1][3]++, 'transparent');
}, function (props) {
  cov_1dg2fatkai().f[2]++;
  cov_1dg2fatkai().s[5]++;
  return "calc(".concat(font.sizeL, "*").concat(props.lines, ")");
}, function (props) {
  cov_1dg2fatkai().f[3]++;
  cov_1dg2fatkai().s[6]++;
  return (cov_1dg2fatkai().b[2][0]++, props.maxLines) && (cov_1dg2fatkai().b[2][1]++, "\n    &:hover {\n      -webkit-line-clamp: ".concat(props.maxLines, ";\n      height: calc(").concat(font.sizeL, "*").concat(props.maxLines, ");\n    }"));
}, function (props) {
  cov_1dg2fatkai().f[4]++;
  cov_1dg2fatkai().s[7]++;
  return props.lines;
}, function (props) {
  cov_1dg2fatkai().f[5]++;
  cov_1dg2fatkai().s[8]++;
  return props.lines;
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    &.g-TextPreview.semantic-no-styling {\n      line-height: ", ";\n      font-size: ", ";\n      font-weight: 500;\n    }\n    display: block;\n    display: -webkit-box;\n    font-size: ", ";\n    margin: 0;\n    width: 95%%;\n    height: 100%;\n    line-height: ", ";\n    overflow: hidden;\n    white-space: normal;\n    z-index: 2;\n    margin-top: ", ";\n    color: var(--subtleTextColor, #4a4458);\n    background-color: ", ";\n    -webkit-transition: height 0.5s; /* Safari */\n    transition: height 0.5s;\n    height: ", ";\n    ", ";\n    text-overflow: ellipsis;\n    @supports (-webkit-line-clamp: ", ") {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-line-clamp: ", ";\n      -webkit-box-orient: vertical;\n      &:after {\n        display: none;\n      }\n    }\n  "])), _themeMapper.evolutionTheme.typography.caption1.lineHeight, _themeMapper.evolutionTheme.typography.caption1.fontSize, _themeMapper.evolutionTheme.typography.caption1.fontSize, _themeMapper.evolutionTheme.typography.caption1.lineHeight, spacing.xsmall, function (props) {
  cov_1dg2fatkai().f[6]++;
  cov_1dg2fatkai().s[9]++;
  return (cov_1dg2fatkai().b[3][0]++, props.theme) && (cov_1dg2fatkai().b[3][1]++, props.theme.textPreview) && (cov_1dg2fatkai().b[3][2]++, props.theme.textPreview.backgroundColor) || (cov_1dg2fatkai().b[3][3]++, 'transparent');
}, function (props) {
  cov_1dg2fatkai().f[7]++;
  cov_1dg2fatkai().s[10]++;
  return "calc(".concat(_themeMapper.evolutionTheme.typography.caption1.lineHeight, "*").concat(props.lines, ")");
}, function (props) {
  cov_1dg2fatkai().f[8]++;
  cov_1dg2fatkai().s[11]++;
  return (cov_1dg2fatkai().b[4][0]++, props.maxLines) && (cov_1dg2fatkai().b[4][1]++, "\n    &:hover {\n      -webkit-line-clamp: ".concat(props.maxLines, ";\n      height: calc(").concat(font.sizeL, "*").concat(props.maxLines, ");\n    }"));
}, function (props) {
  cov_1dg2fatkai().f[9]++;
  cov_1dg2fatkai().s[12]++;
  return props.lines;
}, function (props) {
  cov_1dg2fatkai().f[10]++;
  cov_1dg2fatkai().s[13]++;
  return props.lines;
}))));
cov_1dg2fatkai().s[14]++;
var TextPreview = function TextPreview(_ref2) {
  var lines = _ref2.lines,
    maxLines = _ref2.maxLines,
    children = _ref2.children,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  cov_1dg2fatkai().f[11]++;
  cov_1dg2fatkai().s[15]++;
  return /*#__PURE__*/_react.default.createElement(Text, (0, _extends2.default)({
    lines: lines,
    maxLines: maxLines
  }, props, {
    dangerouslySetInnerHTML: {
      __html: children
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 3
    }
  }));
};
cov_1dg2fatkai().s[16]++;
TextPreview.propTypes = {
  /** Number of lines */
  lines: _propTypes.default.number.isRequired,
  /** Max lines of paragraph */
  maxLines: _propTypes.default.number,
  /** The content of description */
  children: _propTypes.default.node.isRequired,
  /** Theme context */
  themeQueries: _utils.WithThemeQueriesType,
  currentTheme: _propTypes.default.string
};
cov_1dg2fatkai().s[17]++;
TextPreview.defaultProps = {
  lines: 3,
  maxLines: 0,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  themeQueries: {},
  currentTheme: _themeProvider.DEFAULT_THEME_CONTEXT.theme
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(TextPreview));